import React from 'react';
import classNames from 'classnames';

export type ModalFooterProps = {
  className?: string;
  children?: React.ReactNode;
};

export const ModalFooter = ({ className, children }: ModalFooterProps) => (
  <div className={classNames('flex justify-end space-x-2 mt-8', className)}>
    {children}
  </div>
);
